import { useUrlSearchParams } from "@frend-digital/ui/next";
import { useCallback, useMemo } from "react";

export const useModal = (key: string) => {
	const searchParams = useUrlSearchParams({
		replace: true,
	});

	const setOpen = useCallback(
		(open: boolean) => {
			if (open) {
				if (!searchParams.has(key)) {
					searchParams.set(key, "open");
				}
			} else if (searchParams.has(key)) {
				searchParams.delete(key);
			}
		},
		[key, searchParams],
	);

	return useMemo(() => {
		return {
			open: searchParams.has(key),
			setOpen,
		};
	}, [key, searchParams, setOpen]);
};
